export enum CandidateNoteSection {
  ResumeReview = 'resume_review',
  SkillsAssessment = 'skills_assessment',
  Interview = 'interview',
  Other = 'other'
}

export function getCandidateNoteSectionLabel(section: CandidateNoteSection): string {
  switch (section) {
    case CandidateNoteSection.ResumeReview:
      return 'Resume Review';
    case CandidateNoteSection.SkillsAssessment:
      return 'Skills Assessment';
    case CandidateNoteSection.Interview:
      return 'Interview';
    case CandidateNoteSection.Other:
      return 'Other';
    default:
      return 'Unknown';
  }
}
